import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import OrderVehicleForm, {
  OrderVehicleFormProps,
} from '@/components/forms/OrderVehicleForm/OrderVehicleForm';

type OrderVehicleFormContainerProps = Omit<
  OrderVehicleFormProps,
  'financeCalculationResult'
>;

const OrderVehicleFormContainer: FC<
  React.PropsWithChildren<
    React.PropsWithChildren<OrderVehicleFormContainerProps>
  >
> = (ownProps) => {
  const { monthlyInstallment, downPayment, duration, mileage } = useSelector(
    (state: any) => state.pages.pdp.vehicle.financing || { type: null }
  );

  return (
    <OrderVehicleForm
      {...ownProps}
      financeCalculationResult={{
        monthlyInstallment,
        downPayment,
        duration,
        mileage,
      }}
    />
  );
};

export default OrderVehicleFormContainer;
